import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ArrowUpRight } from "@phosphor-icons/react/ArrowUpRight";
import { paths } from "config/paths";
import RouterLink from "next/link";
import { sectionSpacing } from "./section-spacing";
import { headingFontFamily } from "../heading-font";

export interface PricingTeaserContent {
	heading: string;
	subHeading: string;
	ctaLabel: string;
}

export function PricingTeaser({
	content: teaser,
}: {
	content: PricingTeaserContent;
}) {
	return (
		<Box
			sx={{
				bgcolor: "var(--mui-palette-background-level1)",
				py: sectionSpacing,
			}}>
			<Container maxWidth="lg">
				<Stack
					spacing={3}
					sx={{ alignItems: "center", textAlign: "center" }}>
					<Typography
						sx={{ fontFamily: headingFontFamily }}
						variant="h3">
						{teaser.heading}
					</Typography>
					<Typography color="text.secondary">{teaser.subHeading}</Typography>
					<div>
						<Button
							component={RouterLink}
							endIcon={<ArrowUpRight />}
							href={paths.pricing}
							size="large"
							variant="text">
							{teaser.ctaLabel}
						</Button>
					</div>
				</Stack>
			</Container>
		</Box>
	);
}
